export const IMAGE_MIME_TYPES = {
    PNG: 'image/png',
    JPEG: 'image/jpeg',
    SVG: 'image/svg+xml',
    WEBP: 'image/webp',
};

export const ALLOWED_IMAGE_TYPES: string[] = [
    IMAGE_MIME_TYPES.PNG,
    IMAGE_MIME_TYPES.JPEG,
    IMAGE_MIME_TYPES.SVG,
    IMAGE_MIME_TYPES.WEBP,
];

const mimeToExtensionMap: Record<string, string> = {
    [IMAGE_MIME_TYPES.PNG]: '.png',
    [IMAGE_MIME_TYPES.JPEG]: '.jpg,.jpeg',
    [IMAGE_MIME_TYPES.SVG]: '.svg',
    [IMAGE_MIME_TYPES.WEBP]: '.webp',
};

export const ACCEPTED_IMAGE_FORMATS = ALLOWED_IMAGE_TYPES.map(
    (type) => mimeToExtensionMap[type] || ''
).join(',');
